export interface ConnectionsOptions {
    container: HTMLDivElement;
    edges: ConnectionEdge[];
}

export interface ConnectionNode {
    x: number;
    y: number;
    // onMove: e5.Signal<[ConnectionNode]>;
}

export interface ConnectionEdge {
    source: ConnectionNode;
    target: ConnectionNode;
    color: string;
    colorEnd?: string;
}

export class Connections {

    private _element: HTMLCanvasElement;
    private _options: ConnectionsOptions;
    private _resize = e5.Resize.create();

    constructor(options: ConnectionsOptions) {
        options = e5.object.merge({
            container: null
        }, options);
        this._options = options;

        this._element = document.createElement("canvas");
        this._element.className = "connections";

        if (options.container) {
            options.container.appendChild(this._element);
        }

        this._resize.element = this._element;
        this._resize.add(() => this.draw());
    }

    private hexToRgb(hex: string) {
        hex = hex.trim();
        return hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
            , (m, r, g, b) => '#' + r + r + g + g + b + b)
            .substring(1).match(/.{2}/g)
            .map(x => parseInt(x, 16));
    }

    private draw(): void {

        const can = this._element;
        can.width = this._element.offsetWidth;
        can.height = this._element.offsetHeight;

        const ctx = can.getContext("2d");
        ctx.clearRect(0, 0, can.width, can.height);
        ctx.lineWidth = 1;
        ctx.globalAlpha = 0.75;


        for (let edge of this._options.edges) {


            


            // ctx.strokeStyle = edge.color;

            const grad = ctx.createLinearGradient(edge.source.x, edge.source.y + 240, edge.target.x, edge.target.y);
            const rgb = this.hexToRgb(edge.color);
            grad.addColorStop(0, `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0)`);
            grad.addColorStop(1, edge.color);
            ctx.strokeStyle = grad;

            ctx.beginPath();

            // let cenX = edge.target.x + (edge.source.x - edge.target.x) * 0.5;
            // let cenY = edge.target.y + (edge.source.y - edge.target.y) * 0.65;
            // ctx.moveTo(edge.source.x, edge.source.y);
            // ctx.quadraticCurveTo(edge.source.x, cenY, cenX, cenY);
            // ctx.quadraticCurveTo(edge.target.x, cenY, edge.target.x, edge.target.y);


            // ctx.moveTo(edge.source.x, edge.source.y);
            // ctx.arc(edge.source.x, edge.source.y + 5, 5, -Math.PI * 0.5, Math.PI * 2);

            ctx.moveTo(edge.source.x - 5, edge.source.y);
            ctx.lineTo(edge.source.x + 5, edge.source.y);

            ctx.moveTo(edge.source.x, edge.source.y);
            ctx.quadraticCurveTo(edge.source.x, edge.target.y, edge.target.x, edge.target.y);


            // ctx.moveTo(edge.source.x, edge.source.y);
            // ctx.lineTo(edge.target.x, edge.target.y);

            ctx.stroke();
        }
    }
}